module.exports = __webpack_public_path__ + "static/media/chinese_02.9c445d6b.jpg";